<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import './css/map.scss';
  import type { Map } from '../types';
  import { getContext } from 'svelte';

  export let properties: Map;
  export let settings;

  $: ({
    button,
    callouts,
    description,
    headline,
    image,
    subheadline,
    useCustomImage,
  } = properties);

  $: ({ websiteData } = settings);

  let city = getContext<Object>('city');
  let dynamicMapImage;
  let defaultCity;

  $: {
    defaultCity = {
      Name: websiteData?.locationCity,
      'Canonical Name': `${websiteData?.locationCity}, ${websiteData?.locationState}, ${websiteData?.locationCountry}`,
      State: websiteData?.locationState,
    };

    dynamicMapImage =
      typeof useCustomImage != 'undefined' && useCustomImage
        ? null
        : city
          ? `https://maps.googleapis.com/maps/api/staticmap?zoom=13&center=${city['Canonical Name']}&visible=${city['Name']}&style=feature:poi|visibility:off&markers=color:red|${city['Canonical Name']}&size=512x512&key=AIzaSyDAXkfEynm1HTkUR9cVbLosGjxT-IWVTvI`
          : `https://maps.googleapis.com/maps/api/staticmap?zoom=13&center=${defaultCity['Canonical Name']}&visible=${defaultCity?.Name}&style=feature:poi|visibility:off&markers=color:red|${defaultCity['Canonical Name']}&size=512x512&key=AIzaSyDAXkfEynm1HTkUR9cVbLosGjxT-IWVTvI`;
  }
</script>

<section class="our-service-area">
  <div class="wrapper">
    <div class="service-area-top">
      <h2 class="h2">
        {@html headline?.value}
        <span>{@html subheadline?.value}</span>
      </h2>
      <p class="sub-text">
        {@html description?.richText}
      </p>
    </div>
    <div class="image">
      <img loading="lazy" src={dynamicMapImage || image?.value} alt="a map" />
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          id="cities-book-now"
          class="primary-button open-form-js"
          href={getHref(button.link_type, button.link)}
          >{@html button.label}
        </a>
        <div class="small-text-box">
          {#each callouts.value as item}
            <div>
              <BulletPoint bulletIcon={callouts?.icon} />
              <p class="text-small">{@html item}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
